import { useContext } from 'react'
import CashboxContext from '../contexts/CashboxContext'

export default function useCashbox() {
    return useContext(CashboxContext)
}
